import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody";
import Card from "components/Card/Card";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
//@ts-ignore
import { saveAs } from "file-saver";

import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useRootSelector, useRootDispatch } from "hooks/reduxHooks";
import intl from "react-intl-universal";
import { useUserLoggedIn } from "hooks/userHooks";
import { setLicensesAction } from "store/licenses/licenses.actions";
import { createLicense, getLicensesByCompany, getUsersByCompany } from "spectral-core/api";
import axios from "axios";
import { logoutAction } from "store/user/user.actions";
import SpinLoading from "components/Loading/SpinLoading";
import CardLicense, { LicenseForm } from "components/CardLicense/CardLicense";
import { Button, makeStyles } from "@material-ui/core";
import LicenseDialog from "components/Dialogs/LicenseDialog";
import License, { SpectralService, LicenseStatus, LicenseFilter } from "spectral-core/models/License";
import LicenseCreationDTO from "spectral-core/dtos/LicenseCreationDTO";
import { Add, PlusOne } from "@material-ui/icons";
import Snackbar from "components/Snackbar/Snackbar";
import BuildLicenseSheet from "utils/buildLicenseSheet";
import LicenseFilterMenu from "components/Filters/LicenseFilterMenu";
import User from "spectral-core/models/User";

const useStyles = makeStyles((theme) => ({
    reportButtom: {
        backgroundColor: "#33c481",
        border: "none",
        borderRadius: 5,
        color: "white",
        padding: 15,
        textAlign: "center",
        textDecoration: "none",
        display: "inline-block",
        fontSize: 16,
        cursor: "pointer",
        fontFamily: "Roboto",
        fontWeight: "lighter",
        lineHeight: "1.5em",
        minWidth: 160
    }
}))

const toLicenseCreationDTO = (license: LicenseForm): LicenseCreationDTO => {
    const devicesFormated = license.devices.length > 1 
        ? license.devices.split(",").map(d => d.trim()) 
        : license.devices

    return {
        name: license.name,
        description: license.description,
        price: license.price,
        expiresAt: new Date(license.expiresAt).toISOString(),
        service: license.service,
        users: JSON.stringify(license.users),
        isDeviceRestrict: license.isDeviceRestrict,
        devices: JSON.stringify(devicesFormated),
        isModelRestrict: license.isModelRestrict,
        models: JSON.stringify(license.models),
        computerMac: license.computerMac
    };
}

export default function Licenses() {
    const classes = useStyles();

    const licenses = useRootSelector(
        (state) => state.licenses.licenses
    );

    const accessToken = useRootSelector(
        (state) => state.user.currentToken?.accessToken
    );
    const [loading, setLoading] = useState(false); 

    const [isCreateDialogOpened, setIsCreateDialogOpened] = useState(false);

    const [newLicense, setNewLicense] = useState<License>({
        rowKey: "",
        timestamp: new Date(),
        updatedAt: new Date(),
        name: "",
        description: "",
        daysToExpire: 0,
        status: LicenseStatus.Valid,
        price: 0,
        expiresAt: new Date(),
        validationToken: "",
        service: SpectralService.Mobile,
        users: "",
        isDeviceRestrict: false,
        devices: "",
        isModelRestrict: false,
        models: "",
        computerMac: "",
        isActive: true
    });

    const defaultFilter = {
        service: null,
        status: null,
        name: "",
        users: null
    };

    const [filter, setFilter] = useState<LicenseFilter>(defaultFilter);

    const [users, setUsers] = useState<User[]>([]);

    const [snackbarSuccessMsg, setSnackbarSuccessMsg] = useState<string>();
    const [snackbarFailMsg, setSnackbarFailMsg] = useState<string>();

    const history = useHistory();
    const dispatch = useRootDispatch();
    const isLoggedIn = useUserLoggedIn();

    useEffect(() => {
        async function getUsersFromApi(){
            if (!isLoggedIn) return;

            if (users.length > 0) return;

            try {
                const usersFromApi = await getUsersByCompany(accessToken!);
                setUsers(usersFromApi);
            } catch (err) {
                console.log(err);
            }
        }
        getUsersFromApi();
        getLicensesFromApi(filter);
    }, [isLoggedIn, accessToken]);
    
    const getLicensesFromApi = async(filter: LicenseFilter) => {
        if (!isLoggedIn) return;

        setLoading(true);

        try {
            const apiLicense = await getLicensesByCompany(accessToken!, filter);
            dispatch(setLicensesAction(apiLicense));
        } catch (err) {
            if (axios.isAxiosError(err)) {
                dispatch(logoutAction());
            }
            console.log(err);
        }
        setLoading(false);
    }

    const creationSaveHandle = async(licenseForm: LicenseForm) => {
        setLoading(true);
        try {
            await createLicense(
                toLicenseCreationDTO(licenseForm),
                accessToken!);
            const apiLicenses = await getLicensesByCompany(accessToken!, filter);
            dispatch(setLicensesAction(apiLicenses));
            showSnackBarHandle(intl.get("license.successfullyCreated"), true);
        } catch (err) {
            console.log(err);
            showSnackBarHandle(intl.get("license.errorOnCreate"), false);
        }
        setIsCreateDialogOpened(false);
        setLoading(false);
    };

    const editionSaveHandle = () => {
        getLicensesFromApi(filter);
    }

    const showSnackBarHandle = (message: string, isSuccess: boolean) => {
        if (isSuccess) {
            setSnackbarSuccessMsg(message);
        } else {
            setSnackbarFailMsg(message);
        }
    }

    const downloadXlsx = () => {
        if (licenses === undefined)
            return;
    
        const xlsx = BuildLicenseSheet(licenses);
        if (xlsx === undefined) return;

        saveAs(
            new Blob([s2ab(xlsx)], { type: "application/octet-stream" }),
            "Licenses.xlsx"
        );
    }

    //@ts-ignore
    const s2ab = (s) => {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  }

    return (
        <>
            <GridContainer>
                 <div>
                    <button 
                        className={classes.reportButtom} 
                        onClick={downloadXlsx}>
                        {intl.get("btn.generateSheet")}
                    </button>
                </div>

                {/*@ts-ignore*/}
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary">
                            <h4>
                                {intl.get("license.licensesAvailable")}
                            </h4>
                        </CardHeader>
                        <CardBody>
                            <>
                                <LicenseFilterMenu
                                    filter={filter}
                                    users={users}
                                    onChangeFilter={setFilter}
                                    onApplyFilters={getLicensesFromApi}
                                />
                                {loading ? (
                                    <SpinLoading />
                                ) : (
                                    <GridContainer spacing={2}>
                                        {licenses && licenses.length > 0 ? (
                                            licenses.map((license, index) => (
                                                <React.Fragment key={index}>
                                                    {/*@ts-ignore*/}
                                                    <GridItem xs={12} md={6} lg={4} xl={2}>
                                                        <CardLicense
                                                            key={license.rowKey} 
                                                            license={license}
                                                            onSave={editionSaveHandle}
                                                            showSnackBar={showSnackBarHandle} />
                                                    </GridItem>
                                                </React.Fragment>
                                            ))
                                        ) : (
                                            /*@ts-ignore*/
                                            <GridItem xs={12}>
                                                <div>{intl.get("license.licensesNotFound")}</div>
                                            </GridItem>
                                        )}
                                    </GridContainer>
                                )}
                            </>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
            <GridContainer>
                <GridItem>
                    <Button 
                        startIcon={<Add />}
                        onClick={() => setIsCreateDialogOpened(!isCreateDialogOpened)}
                        style={{ backgroundColor: "#00acc1", color: "#fff" }}
                        variant="contained">
                        {intl.get("license.create")}
                    </Button>
                </GridItem>
            </GridContainer>
            <LicenseDialog
                open={isCreateDialogOpened}
                license={newLicense}
                expiresAtDisabled={false}
                onClose={() => setIsCreateDialogOpened(false)}
                onSave={creationSaveHandle}
                onCancel={() => setIsCreateDialogOpened(false)}
            />

            <Snackbar
                //@ts-ignore
                style={{ display: "flex", position: "initial" }}
                place="ec"
                color="success"
                message={snackbarSuccessMsg ?? ""}
                open={snackbarSuccessMsg !== undefined}
                closeNotification={() => setSnackbarSuccessMsg(undefined)}
                close
            />
            <Snackbar
                //@ts-ignore
                style={{ display: "flex", position: "initial" }}
                place="ec"
                color="fail"
                message={snackbarFailMsg ?? ""}
                open={snackbarFailMsg !== undefined}
                closeNotification={() => setSnackbarFailMsg(undefined)}
                close
            />
        </>
    );
}

